import { StoreOption } from "../components/passes/guest/type";
import { PassLocation } from "../models/IPassLocation";

export const sortPassLocations =  (locations: PassLocation[]): StoreOption[] => {
    return locations
        .sort((a, b) => a.store.localeCompare(b.store))
        .map((store) => ({
            value: store.passLocationId,
            label: store.store,
            shoppingDays: store.shoppingDays
        })) || [];
};